import { render, staticRenderFns } from "./senders-detail.vue?vue&type=template&id=56bb5470"
import script from "./senders-detail.vue?vue&type=script&lang=js"
export * from "./senders-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports